import cloneDeep from "lodash/cloneDeep";
import {
  GET_CONTENT,
  GET_CONTENT_BAD_SECTION_REQUEST,
  GET_CONTENT_SUCCESS,
  GET_CONTENT_ERROR,
  GET_SECTION,
  GET_SECTION_SUCCESS,
  GET_SECTION_ERROR,
  GET_SECTION_LOAD_EXISTING,
  GET_DETAILS_SECTION,
  GET_DETAILS_SECTION_SUCCESS,
  GET_DETAILS_SECTION_ERROR,
  GET_DETAILS_SECTION_LOAD_EXISTING,
  DRUG_MOBILE_TOC_SET_TAB,
  GET_PRINT_SECTIONS,
  GET_PRINT_SECTIONS_SUCCESS,
  GET_PRINT_SECTIONS_ERROR,
  GET_PRINT_DETAILS_SECTIONS,
  GET_PRINT_DETAILS_SECTIONS_SUCCESS,
  GET_PRINT_DETAILS_SECTIONS_ERROR,
  SET_ACTIVE_TOC_ITEM,
  SHOW_ERROR,
  HIDE_ERROR,
  COLLECT_ITEM_VIEWS_EVENT,
  POST_ITEM_VIEWS,
  POST_ITEM_VIEWS_SUCCESS,
  POST_ITEM_VIEWS_ERROR,
  SET_ACTIVE_VIDEO,
  GET_FT_LINKS,
  GET_FT_LINKS_SUCCESS,
  GET_FT_LINKS_ERROR,
  PUT_CONTENT_BOOKMARK_SUCCESS,
  PUT_CONTENT_BOOKMARK_ERROR,
  PUT_CONTENT_BOOKMARK,
  DELETE_CONTENT_BOOKMARK_SUCCESS,
  DELETE_CONTENT_BOOKMARK_ERROR,
  DELETE_CONTENT_BOOKMARK,
  PUT_CONTENT_FOLLOW_SUCCESS,
  PUT_CONTENT_FOLLOW_ERROR,
  PUT_CONTENT_FOLLOW,
  DELETE_CONTENT_FOLLOW_SUCCESS,
  DELETE_CONTENT_FOLLOW_ERROR,
  DELETE_CONTENT_FOLLOW,
  ADD_CONTENT_NOTIFICATION,
  CLEAR_CONTENT_NOTIFICATION,
  COPY_TO_CLIPBOARD_SUCCESS,
  COPY_TO_CLIPBOARD_ERROR,
  MARK_FULL_TOPIC_LOADED,
  GET_FULL_TOPIC_SUCCESS,
  GET_FULL_TOPIC,
  GET_FULL_TOPIC_ERROR,
  PREPROCESS_FULL_TOPIC,
  PREPROCESS_FULL_TOPIC_SUCCESS,
  PREPROCESS_FULL_TOPIC_ERROR,
  CLEAR_FULL_TOPIC_ERROR,
  GET_ALL_SECTIONS_SUCCESS,
  GET_ALL_SECTIONS_ERROR,
  SAVE_CLOUDINARY_TOKEN,
  GET_MERATIVE_LINK_WITH_TOKEN_SUCCESS,
  GET_MERATIVE_LINK_WITH_TOKEN_ERROR,
  CLEAR_MERATIVE_LINK_WITH_TOKEN,
  GET_SHARE_DATA,
  GET_SHARE_DATA_SUCCESS,
  GET_SHARE_DATA_ERROR,
  INITIALIZE_STORE,
} from "./constants";
import { getBreadcrumbMap } from "../util/getBreadcrumbMap";
import {
  findNextEnabledSection,
  findPreviousEnabledSection,
} from "../util/findNextPreviousEnabledSectionHashes";
import { drugMobileTocTabTypes } from "../constants/drug-mobile-toc-tab-types";

//NOTICE:
//This initialState object is
//  used to reset store value
//  when navigate to a diffrent topic
//  by INITIALIZE_STORE action from useContent hook
//  this is called every time either route pubtype or title value is changed
//This initialState object should
//  remain immutable
//  access only by deep clone
//  without direct modification
//Any store value should have a default value that is reset when navigate to a diffrent topic
//unless have a very compelling reason.
//Only exception so far is idToSectionMap which DH and DM/X expect different default value
//-------------------------------------------------------------------------
//  Make sure to udpate initialState whenever a new store value is added
//-------------------------------------------------------------------------
const initialState = {
  isErrorMsgShown: false,
  toc: [],
  activeTocItem: null,
  lastHash: "",
  isContentFetching: false,
  hasContentFetched: false,
  isDetailsSectionFetching: false,
  nextSectionHash: null,
  previousSectionHash: null,
  ancillaryData: [],
  transformData: {},
  referenceData: {},
  breadcrumbData: [],
  userExperience: {
    shouldTrackUsage: false,
  },
  baseMediaUrls: {},
  ftLinks: {
    isFetching: false,
    hasFetched: false,
    apiError: false,
    targetLinks: [],
  },
  metadata: {},
  multimedia: {},
  isLoading: true,
  hasError: false,
  isBookmarking: false,
  isFollowing: false,
  userHistory: {
    itemviews: [],
    itemviewsPosting: [],
    isPosting: false,
    error: null,
  },
  notification: {
    isOpen: false,
  },
  hasPrintFailed: false,
  isFullTopicLoading: false,
  isFullTopicLoaded: false,
  fullTopicLoadingError: "",
  isFullTopicPreprocessing: false,
  fullTopicPreprocessingError: "",
  cloudinaryToken: "",
  drugDetails: {},
  tablesContent: {},
  drugMobileTocActiveTab: "",
  merativeLinkWithToken: undefined,
  about: undefined,
  activeDetailsSectionIndex: 0,
  activeDetailsSubSectionIndex: 0,
  activeSectionIndex: undefined,
  careInterventionsSectionId: undefined,
  checklist: undefined,
  contentSections: undefined,
  contentSectionCache: [],
  detailsSectionCache: [[{}]],
  errorData: undefined,
  header: undefined,
  headerTools: undefined,
  loadedSection: undefined,
  loe: undefined,
  pubTypeLogos: undefined,
  referenceSectionId: undefined,
  styleConfig: undefined,
  subscription: undefined,
  tabs: undefined,
  updates: undefined,
  workplaceData: undefined,
  shareLinkDataError: undefined,
  isFetchingForShareData: false,
  crossContentReferenceLinks: undefined,
};

export const getInitialState = () => cloneDeep(initialState);

const findPreviousSection = (startIndex, toc) => {
  const possibleIndex = startIndex - 1;
  if (possibleIndex >= 0) {
    const possibleSection = toc[possibleIndex];
    if (possibleSection) {
      return possibleSection.reference;
    }
  }

  return null;
};

const findNextSection = (startIndex, toc) => {
  const possibleIndex = startIndex + 1;
  if (possibleIndex < toc.length) {
    const possibleSection = toc[possibleIndex];
    if (possibleSection) {
      return possibleSection.reference;
    }
  }

  return null;
};

const getNextPreviousSectionHashes = (
  payload,
  currentHash,
  contentSectionCache
) => {
  const { idToSectionMap, toc, userExperience } = payload;
  const { isPreviewMode, isFreeArticle } = userExperience;
  const isNonFreePreview = isPreviewMode && !isFreeArticle;
  const currentSectionIndex = idToSectionMap?.[currentHash]?.index;
  let previousSectionHash = null;
  let nextSectionHash = null;
  if (typeof currentSectionIndex === "number") {
    previousSectionHash = !isNonFreePreview
      ? findPreviousSection(currentSectionIndex, toc)
      : findPreviousEnabledSection(contentSectionCache, currentSectionIndex);
    nextSectionHash = !isNonFreePreview
      ? findNextSection(currentSectionIndex, toc)
      : findNextEnabledSection(contentSectionCache, currentSectionIndex);
  }
  return { previousSectionHash, nextSectionHash };
};

const getSectionNameDictionary = (detailsSectionMap) => {
  //This data validation should be done in the experience
  //needed to match sectionId with new lowercase data
  const sectionNameDictionary = [];
  for (const sectionName in detailsSectionMap) {
    if (detailsSectionMap.hasOwnProperty(sectionName)) {
      const lowerCaseSectionName = sectionName.toLowerCase();
      sectionNameDictionary[lowerCaseSectionName] = sectionName;
    }
  }
  return sectionNameDictionary;
};

export function reducer(state, { type, payload, error }) {
  switch (type) {
    case GET_CONTENT: {
      return {
        ...state,
        isLoading: true,
        hasError: false,
        isContentFetching: true,
        hasContentFetched: false,
      };
    }

    case GET_CONTENT_SUCCESS: {
      let contentSectionCache;
      let activeSectionIndex = 0;
      let hasSetIndex = false;
      let detailsSectionCache;
      let activeDetailsSectionIndex = 0;
      let activeDetailsSubSectionIndex = 0;
      let loadedSection = "Not Loaded";
      let section = { html: "Loading..." };
      let initialSection;
      const {
        idToSectionMap,
        contentSections,
        drugDetails,
        sectionIds,
      } = payload;

      if (contentSections?.length > 0) {
        initialSection = contentSections[0];
        if (initialSection.id) {
          loadedSection = initialSection.id;
          section = initialSection;
        }
      }

      if (idToSectionMap) {
        // initial contentSectionCache with a toc length array of undefined
        // fill due to sparse array might act unexpectedly in some situations
        contentSectionCache = Array(payload.toc?.length).fill(undefined);
        contentSections.forEach((item) => {
          const sectionIndex = idToSectionMap[item.id]?.index ?? -1;
          if (sectionIndex > -1) {
            contentSectionCache[sectionIndex] = item;
            // set the activeSectionIndex to first section returned
            if (!hasSetIndex) {
              activeSectionIndex = sectionIndex;
              hasSetIndex = true;
            }
          }
        });
      } else {
        // if idToSectionMap does not exist put all contentSections into contentSectionCache
        // this is for safeguarding of content with isSplitContent flag but no idToSectionMap
        contentSectionCache = contentSections;
      }

      const {
        nextSectionHash,
        previousSectionHash,
      } = getNextPreviousSectionHashes(
        payload,
        section.id,
        contentSectionCache
      );

      const referenceContent = payload.contentSections?.find(
        (localSection) => localSection.title === "References"
      )?.subSections;
      const referenceData = {};
      if (referenceContent) {
        referenceContent.forEach((subSection) => {
          referenceData[subSection.id] = subSection.data;
        });
      }
      // this just resets workplaceData each time since content may not always have workplaceData for notes
      let workplaceData = {};
      if (payload.workplaceData) {
        workplaceData = payload.workplaceData;
      }

      const metadata = payload.metadata;

      // Build breadcrumb from TOC
      const breadcrumbMap = payload.toc ? getBreadcrumbMap(payload.toc) : [];
      const firstItem = Object.keys(breadcrumbMap)[0];

      // set the activeTocItem
      let activeTocItem = "";
      if (payload.userExperience.isSplitContent) {
        activeTocItem = payload.contentSections[0]?.id;
      } else {
        if (!payload?.sectionIds?.length) {
          activeTocItem = payload.toc[0]?.reference;
        }
      }
      if (drugDetails) {
        detailsSectionCache = drugDetails?.toc?.map((element) => {
          return Array(element.subSection.length).fill(undefined);
        });

        const detailsSection = drugDetails.sections?.[0];
        drugDetails.activeSectionId = detailsSection?.sectionId;
        const { sectionIndex = -1, subSectionIndex = -1 } =
          drugDetails.sectionMap?.[detailsSection?.sectionId] ?? {};
        if (sectionIndex > -1 && subSectionIndex > -1) {
          detailsSectionCache[sectionIndex][subSectionIndex] = detailsSection;
          activeDetailsSectionIndex = sectionIndex;
          activeDetailsSubSectionIndex = subSectionIndex;
        }

        const drugDetailsBreadcrumbMap = drugDetails.toc
          ? getBreadcrumbMap(drugDetails.toc)
          : {};
        drugDetails.breadcrumbMap = drugDetailsBreadcrumbMap;
        drugDetails.breadcrumbData =
          drugDetailsBreadcrumbMap[drugDetails.activeSectionId] ?? [];
      }

      return {
        ...state,
        ...payload,
        contentSectionCache,
        activeTocItem,
        activeSectionIndex,
        isContentFetching: false,
        hasContentFetched: true,
        detailsSectionCache,
        activeDetailsSectionIndex,
        activeDetailsSubSectionIndex,
        referenceData,
        workplaceData,
        breadcrumbMap,
        breadcrumbData: breadcrumbMap[firstItem],
        metadata,
        isLoading: false,
        nextSectionHash,
        previousSectionHash,
        lastHash: sectionIds?.[0],
        loadedSection,
        idToSectionMap,
      };
    }

    case GET_PRINT_SECTIONS:
    case GET_SECTION: {
      return {
        ...state,
        isContentFetching: true,
        hasContentFetched: false,
      };
    }

    case GET_PRINT_SECTIONS_ERROR: {
      return {
        ...state,
        isContentFetching: false,
        isErrorMsgShown: false,
        notification: {
          type: "error",
          message: payload?.error,
          isOpen: true,
        },

        hasPrintFailed: true,
      };
    }

    case GET_PRINT_DETAILS_SECTIONS_ERROR: {
      return {
        ...state,
        isDetailsSectionFetching: false,
        isErrorMsgShown: false,
        notification: {
          type: "error",
          message: payload?.error,
          isOpen: true,
        },

        hasPrintFailed: true,
      };
    }

    case GET_SECTION_ERROR: {
      const newState = {
        ...state,
        isContentFetching: false,
        isErrorMsgShown: false,
      };

      newState.notification = {
        type: "error",
        message: payload?.error,
        isOpen: true,
      };

      return newState;
    }

    case GET_SECTION_SUCCESS: {
      let activeSectionIndex = 0;
      const { localHash, section } = payload;
      let { idToSectionMap, contentSectionCache } = state;
      if (idToSectionMap) {
        // initial contentSectionCache with a toc length array of undefined
        // eslint-disable-next-line array-callback-return
        const sectionIndex = idToSectionMap[section.id]?.index ?? -1;
        if (sectionIndex > -1) {
          contentSectionCache[sectionIndex] = section;
          // set the activeSectionIndex to first section returned
          activeSectionIndex = sectionIndex;
        }
      } else {
        // if idToSectionMap does not exist then put section into contentSectionCache
        // and set activeSectionIndex to 0
        // this is for safeguarding of content with isSplitContent flag but no idToSectionMap
        contentSectionCache = section;
      }

      const {
        nextSectionHash,
        previousSectionHash,
      } = getNextPreviousSectionHashes(state, section.id, contentSectionCache);

      return {
        ...state,
        contentSectionCache,
        activeSectionIndex,
        isContentFetching: false,
        hasContentFetched: true,
        hasPrintFailed: false,
        nextSectionHash,
        previousSectionHash,
        lastHash: localHash,
        loadedSection: section.id,
      };
    }

    case GET_PRINT_DETAILS_SECTIONS:
    case GET_DETAILS_SECTION: {
      return {
        ...state,
        isDetailsSectionFetching: true,
      };
    }

    case GET_DETAILS_SECTION_SUCCESS: {
      let activeDetailsSectionIndex = 0;
      let activeDetailsSubSectionIndex = 0;
      const { localHash, detailsSection } = payload;
      let { detailsSectionCache, drugDetails } = state;
      drugDetails.activeSectionId = detailsSection.sectionId;
      const { sectionIndex = -1, subSectionIndex = -1 } =
        drugDetails?.sectionMap?.[detailsSection?.sectionId] ?? {};
      if (sectionIndex > -1 && subSectionIndex > -1) {
        detailsSectionCache[sectionIndex][subSectionIndex] = detailsSection;
        activeDetailsSectionIndex = sectionIndex;
        activeDetailsSubSectionIndex = subSectionIndex;
      } else {
        // if idToSectionMap does not exist then put section into detailsSectionCache
        // and set activeDetailsSectionIndex to 0
        // this is for safeguarding of content with isSplitContent flag but no idToSectionMap
        detailsSectionCache = detailsSection;
      }

      const { breadcrumbMap, activeSectionId } = drugDetails;
      const drugDetailsBreadcrumbData = breadcrumbMap?.[activeSectionId] ?? [];
      drugDetails.breadcrumbData = drugDetailsBreadcrumbData;

      return {
        ...state,
        detailsSectionCache,
        activeDetailsSectionIndex,
        activeDetailsSubSectionIndex,
        isDetailsSectionFetching: false,
        hasPrintFailed: false,
        lastHash: localHash,
      };
    }

    case GET_DETAILS_SECTION_ERROR: {
      const newState = {
        ...state,
        isDetailsSectionFetching: false,
        isErrorMsgShown: false,
      };
      const { drugDetails } = state;
      drugDetails.activeSectionId = payload.sectionId;
      newState.notification = {
        type: "error",
        message: payload?.error,
        isOpen: true,
      };

      return newState;
    }

    case DRUG_MOBILE_TOC_SET_TAB: {
      return {
        ...state,
        drugMobileTocActiveTab: payload,
      };
    }

    /* The similarities between this and GET_ALL_SECTIONS*
       will be refactored in a future PR
    */
    case GET_PRINT_SECTIONS_SUCCESS: {
      const { sections } = payload;
      const { idToSectionMap, contentSectionCache } = state;
      if (idToSectionMap) {
        sections.forEach((section) => {
          const sectionIndex = idToSectionMap[section.id]?.index ?? -1;
          if (sectionIndex > -1) {
            contentSectionCache[sectionIndex] = section;
          }
        });
      }

      return {
        ...state,
        contentSectionCache,
        isContentFetching: false,
        hasContentFetched: true,
        hasPrintFailed: false,
      };
    }

    case GET_PRINT_DETAILS_SECTIONS_SUCCESS: {
      const detailsSections = payload;
      const { drugDetails, detailsSectionCache } = state;

      if (drugDetails?.sectionMap) {
        //This data validation should be done in the experience
        //needed to match sectionId with new lowercase data

        const sectionNameDictionary = getSectionNameDictionary(
          drugDetails?.sectionMap
        );

        detailsSections.forEach((section) => {
          const formattedSectionId = sectionNameDictionary[section.sectionId];
          const sectionIndexes = drugDetails?.sectionMap[formattedSectionId];

          if (sectionIndexes) {
            detailsSectionCache[sectionIndexes.sectionIndex][
              sectionIndexes.subSectionIndex
            ] = { data: section.data, sectionId: formattedSectionId };
          }
        });
      }

      return {
        ...state,
        detailsSectionCache,
        isDetailsSectionFetching: false,
        hasPrintFailed: false,
      };
    }

    case GET_ALL_SECTIONS_ERROR: {
      return {
        ...state,
        isContentFetching: false,
        isErrorMsgShown: false,
        notification: {
          type: "error",
          message: payload?.error,
          isOpen: false,
        },
      };
    }

    case GET_ALL_SECTIONS_SUCCESS: {
      const { sections } = payload;
      const { idToSectionMap, contentSectionCache } = state;
      if (idToSectionMap) {
        sections.forEach((section) => {
          const sectionIndex = idToSectionMap[section.id]?.index ?? -1;
          if (sectionIndex > -1) {
            contentSectionCache[sectionIndex] = section;
          }
        });
      }

      return {
        ...state,
        contentSectionCache,
        hasContentFetched: true,
      };
    }

    case GET_SECTION_LOAD_EXISTING: {
      const { localHash, section, drugMobileTocActiveTab } = payload;
      const { idToSectionMap } = state;
      const sectionIndex = idToSectionMap[section.id]?.index ?? -1;
      const activeSectionIndex = sectionIndex > -1 ? sectionIndex : 0;
      const {
        nextSectionHash,
        previousSectionHash,
      } = getNextPreviousSectionHashes(
        state,
        section.id,
        state.contentSectionCache
      );

      const isFromMobileDrugDetails =
        drugMobileTocActiveTab === drugMobileTocTabTypes.IN_DEPTH_ANSWERS;

      return {
        ...state,
        activeSectionIndex,
        lastHash: localHash,
        nextSectionHash,
        previousSectionHash,
        isContentFetching: false,
        hasContentFetched: true,
        loadedSection: isFromMobileDrugDetails
          ? state.loadedSection
          : section.id,
      };
    }

    case GET_DETAILS_SECTION_LOAD_EXISTING: {
      const { localHash, detailsSection } = payload;
      const { drugDetails } = state;
      const {
        sectionIndex: activeDetailsSectionIndex,
        subSectionIndex: activeDetailsSubSectionIndex,
      } = drugDetails.sectionMap?.[detailsSection?.sectionId] ?? {};
      drugDetails.activeSectionId = detailsSection.sectionId;

      const { breadcrumbMap, activeSectionId } = drugDetails;
      const drugDetailsBreadcrumbData = breadcrumbMap?.[activeSectionId] ?? [];
      drugDetails.breadcrumbData = drugDetailsBreadcrumbData;

      return {
        ...state,
        activeDetailsSectionIndex,
        activeDetailsSubSectionIndex,
        lastHash: localHash,
        isDetailsSectionFetching: false,
        activeSectionId: detailsSection.sectionId,
      };
    }

    case GET_FT_LINKS: {
      return {
        ...state,
        ftLinks: {
          isFetching: true,
          hasFetched: false,
          apiError: false,
          targetLinks: [],
        },
      };
    }

    case GET_FT_LINKS_SUCCESS: {
      return {
        ...state,
        ftLinks: {
          targetLinks: payload?.targetLinks,
          isFetching: false,
          hasFetched: true,
          apiError: false,
        },
      };
    }

    case GET_FT_LINKS_ERROR: {
      return {
        ...state,
        ftLinks: {
          isFetching: false,
          hasFetched: true,
          apiError: true,
          targetLinks: [],
          errorMessage: error,
        },
      };
    }

    case GET_CONTENT_ERROR: {
      return {
        ...state,
        isLoading: false,
        hasError: true,
        errorData: error,
        referenceData: {},
      };
    }

    case GET_CONTENT_BAD_SECTION_REQUEST: {
      return {
        ...state,
        isLoading: false,
        hasError: true,
        notification: {
          type: "error",
          message:
            "Please note that the specific section linked to no longer exists. We apologize for any inconvenience.",
          isOpen: true,
        },
      };
    }

    case SET_ACTIVE_TOC_ITEM: {
      return {
        ...state,
        activeTocItem: payload,
        breadcrumbData: state.breadcrumbMap[payload],
      };
    }

    case SET_ACTIVE_VIDEO: {
      return {
        ...state,
        multimedia: {
          ...state.multimedia,
          playingVideoId: payload,
        },
      };
    }

    case SHOW_ERROR: {
      return {
        ...state,
        isErrorMsgShown: true,
      };
    }

    case HIDE_ERROR: {
      return {
        ...state,
        isErrorMsgShown: false,
      };
    }

    case ADD_CONTENT_NOTIFICATION: {
      return {
        ...state,
        notification: {
          type: "error",
          message: payload?.error,
          isOpen: true,
        },
      };
    }

    case CLEAR_CONTENT_NOTIFICATION: {
      return {
        ...state,
        notification: {
          ...state.notification,
          isOpen: false,
        },
      };
    }

    case PUT_CONTENT_BOOKMARK:
    case DELETE_CONTENT_BOOKMARK: {
      return {
        ...state,
        isBookmarking: true,
      };
    }

    case PUT_CONTENT_BOOKMARK_ERROR:
    case DELETE_CONTENT_BOOKMARK_ERROR: {
      return {
        ...state,
        error: error,
        isBookmarking: false,
      };
    }

    case PUT_CONTENT_BOOKMARK_SUCCESS: {
      const headerTools = [...state.headerTools];
      const bookmarkIndex = headerTools.findIndex(
        (headerTool) => headerTool.action === "bookmark"
      );
      const unBookmarkIndex = headerTools.findIndex(
        (headerTool) => headerTool.action === "unbookmark"
      );
      const tempWhiteListTabTypes =
        headerTools[bookmarkIndex].whiteListTabTypes;
      headerTools[bookmarkIndex] = {
        ...headerTools[bookmarkIndex],
        whiteListTabTypes: [],
      };
      headerTools[unBookmarkIndex] = {
        ...headerTools[unBookmarkIndex],
        whiteListTabTypes: tempWhiteListTabTypes,
      };
      return {
        ...state,
        headerTools,
        isErrorMsgShown: false,
        isBookmarking: false,
      };
    }

    case DELETE_CONTENT_BOOKMARK_SUCCESS: {
      const headerTools = [...state.headerTools];
      const bookmarkIndex = headerTools.findIndex(
        (headerTool) => headerTool.action === "bookmark"
      );
      const unBookmarkIndex = headerTools.findIndex(
        (headerTool) => headerTool.action === "unbookmark"
      );
      const tempWhiteListTabTypes =
        headerTools[unBookmarkIndex].whiteListTabTypes;
      headerTools[unBookmarkIndex] = {
        ...headerTools[unBookmarkIndex],
        whiteListTabTypes: [],
      };
      headerTools[bookmarkIndex] = {
        ...headerTools[bookmarkIndex],
        whiteListTabTypes: tempWhiteListTabTypes,
      };
      return {
        ...state,
        headerTools,
        isErrorMsgShown: false,
        isBookmarking: false,
      };
    }

    case PUT_CONTENT_FOLLOW:
    case DELETE_CONTENT_FOLLOW: {
      return {
        ...state,
        isFollowing: true,
      };
    }

    case PUT_CONTENT_FOLLOW_ERROR:
    case DELETE_CONTENT_FOLLOW_ERROR: {
      return {
        ...state,
        error: error,
        isFollowing: false,
      };
    }

    case PUT_CONTENT_FOLLOW_SUCCESS: {
      const headerTools = [...state.headerTools];
      const followIndex = headerTools.findIndex(
        (headerTool) => headerTool.action === "follow"
      );
      const unFollowIndex = headerTools.findIndex(
        (headerTool) => headerTool.action === "unfollow"
      );
      const tempWhiteListTabTypes = headerTools[followIndex].whiteListTabTypes;
      headerTools[followIndex] = {
        ...headerTools[followIndex],
        whiteListTabTypes: [],
      };
      headerTools[unFollowIndex] = {
        ...headerTools[unFollowIndex],
        whiteListTabTypes: tempWhiteListTabTypes,
      };
      return {
        ...state,
        headerTools,
        isErrorMsgShown: false,
        isFollowing: false,
        notification: {
          type: "success",
          message: payload,
          isOpen: true,
        },
      };
    }

    case DELETE_CONTENT_FOLLOW_SUCCESS: {
      const headerTools = [...state.headerTools];
      const followIndex = headerTools.findIndex(
        (headerTool) => headerTool.action === "follow"
      );
      const unFollowIndex = headerTools.findIndex(
        (headerTool) => headerTool.action === "unfollow"
      );
      const tempWhiteListTabTypes =
        headerTools[unFollowIndex].whiteListTabTypes;
      headerTools[unFollowIndex] = {
        ...headerTools[unFollowIndex],
        whiteListTabTypes: [],
      };
      headerTools[followIndex] = {
        ...headerTools[followIndex],
        whiteListTabTypes: tempWhiteListTabTypes,
      };
      return {
        ...state,
        headerTools,
        isErrorMsgShown: false,
        isFollowing: false,
      };
    }

    case COLLECT_ITEM_VIEWS_EVENT: {
      return {
        ...state,
        userHistory: {
          ...state.userHistory,
          itemviews: [...state.userHistory.itemviews, ...payload],
        },
      };
    }

    case POST_ITEM_VIEWS: {
      return {
        ...state,
        userHistory: {
          ...state.userHistory,
          itemviews: [],
          itemviewsPosting: state.userHistory.itemviews,
          isPosting: true,
        },
      };
    }

    case POST_ITEM_VIEWS_SUCCESS: {
      return {
        ...state,
        userHistory: {
          ...state.userHistory,
          itemviewsPosting: [],
          isPosting: false,
          error: null,
        },
      };
    }

    case POST_ITEM_VIEWS_ERROR: {
      return {
        ...state,
        userHistory: {
          ...state.userHistory,
          itemviews: [
            ...state.userHistory.itemviews,
            ...state.userHistory.itemviewsPosting,
          ],
          itemviewsPosting: [],
          isPosting: false,
          error,
        },
      };
    }

    case COPY_TO_CLIPBOARD_SUCCESS: {
      return {
        ...state,
        notification: {
          type: "success",
          message: payload,
          isOpen: true,
        },
      };
    }

    case COPY_TO_CLIPBOARD_ERROR: {
      return {
        ...state,
        notification: {
          type: "error",
          message: payload,
          isOpen: true,
        },
      };
    }

    case GET_FULL_TOPIC: {
      return {
        ...state,
        isFullTopicLoading: true,
        isFullTopicLoaded: false,
        fullTopicLoadingError: "",
      };
    }

    case MARK_FULL_TOPIC_LOADED:
      return {
        ...state,
        isFullTopicLoaded: true,
      };

    case GET_FULL_TOPIC_SUCCESS: {
      const { contentSections, idToSectionMap } = payload;
      let updatedContentSectionCache = [...state.contentSectionCache];

      if (idToSectionMap) {
        contentSections.forEach((item) => {
          const sectionIndex = idToSectionMap[item.id]?.index ?? -1;
          if (sectionIndex > -1) {
            updatedContentSectionCache[sectionIndex] = item;
          }
        });
      } else {
        updatedContentSectionCache = contentSections;
      }

      return {
        ...state,
        contentSectionCache: updatedContentSectionCache,
        idToSectionMap,
        isFullTopicLoading: false,
        isFullTopicLoaded: true,
      };
    }

    case GET_FULL_TOPIC_ERROR: {
      return {
        ...state,
        isFullTopicLoading: false,
        isFullTopicLoaded: false,
        fullTopicLoadingError: error,
      };
    }

    case CLEAR_FULL_TOPIC_ERROR: {
      return {
        ...state,
        fullTopicLoadingError: "",
      };
    }

    case PREPROCESS_FULL_TOPIC: {
      return {
        ...state,
        isFullTopicPreprocessing: true,
        fullTopicPreprocessingError: "",
      };
    }

    case PREPROCESS_FULL_TOPIC_SUCCESS: {
      return {
        ...state,
        isFullTopicPreprocessing: false,
      };
    }

    case PREPROCESS_FULL_TOPIC_ERROR: {
      return {
        ...state,
        isFullTopicPreprocessing: false,
        fullTopicPreprocessingError: error,
      };
    }

    case SAVE_CLOUDINARY_TOKEN: {
      return {
        ...state,
        cloudinaryToken: payload,
      };
    }

    case GET_MERATIVE_LINK_WITH_TOKEN_SUCCESS: {
      const { merativeLink } = payload;
      return {
        ...state,
        isErrorMsgShown: false,
        merativeLinkWithToken: merativeLink,
      };
    }

    case GET_MERATIVE_LINK_WITH_TOKEN_ERROR: {
      return {
        ...state,
        isErrorMsgShown: false,
        notification: {
          type: "error",
          message: payload?.error,
          isOpen: true,
        },
      };
    }

    case CLEAR_MERATIVE_LINK_WITH_TOKEN: {
      return {
        ...state,
        merativeLinkWithToken: undefined,
      };
    }

    case GET_SHARE_DATA: {
      return {
        ...state,
        isFetchingForShareData: true,
        shareDetailsDataError: null,
        internalShareLink: null,
        externalShareLink: null,
      };
    }

    case GET_SHARE_DATA_SUCCESS: {
      return {
        ...state,
        internalShareLink: payload.internalShareLink,
        externalShareLink: payload.externalShareLink,
        isFetchingForShareData: false,
      };
    }

    case GET_SHARE_DATA_ERROR: {
      return {
        ...state,
        isFetchingForShareData: false,
        shareDetailsDataError: error,
      };
    }

    case INITIALIZE_STORE: {
      return {
        ...state,
        ...getInitialState(),
      };
    }

    default: {
      return state;
    }
  }
}
